import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSegmentPriceBookInfo = createAsyncThunk("fetchSegmentPriceBookInfo", async (id) => {
	const response = await axiosHttp.get(`price-book/segment/${id}`);
	return response.data.data;
});

const SegmentPriceBookInfoSlice = createSlice({
	name: "SegmentPriceBookInfoSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSegmentPriceBookInfo.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSegmentPriceBookInfo.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchSegmentPriceBookInfo.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SegmentPriceBookInfoSlice.reducer;
